import { Component, inject } from '@angular/core';
import { FrameDetectionService } from './modules/shared/services/frame-detection.service';
import { UrlSynchronizationService } from './modules/shared/services/url-synchronization.service';

@Component({
  standalone: false,
  selector: 'app-cyborg',
  templateUrl: 'app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  private urlSynchronizationService = inject(UrlSynchronizationService);
  private frameDetectionService = inject(FrameDetectionService);

  constructor() {
    // If the app is running in an iframe (i.e. within Verity), start URL synchronization
    if (this.frameDetectionService.isIframe()) {
      this.urlSynchronizationService.listenToRouterEvents();
    }
  }
}
